import { Form, Input, Space } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import { ConfigCard } from './styles'

const { TextArea } = Input

const TextareaDescription = ({ initialDescription, maxLength }) => {
	return (
		<ConfigCard title="Descrição">
			<Space direction="vertical" style={{ width: '100%' }}>
				<Form.Item name="description" initialValue={initialDescription}>
					<TextArea
						placeholder="Digite uma descrição"
						maxLength={maxLength}
						autoSize={{ minRows: 3, maxRows: 6 }}
					/>
				</Form.Item>
			</Space>
		</ConfigCard>
	)
}

TextareaDescription.propTypes = {
	initialDescription: PropTypes.string,
	maxLength: PropTypes.number,
}

export default TextareaDescription
